import { Link } from "react-router-dom";
import React, { useState, useContext, useEffect, useMemo } from "react";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import AgGridTable from "../components/ui/AgGridTable";
import { ColDef } from "ag-grid-community";
import { Eye } from "lucide-react";

interface Policies {
  _id: string;
  description: string;
  type: string;
}

export default () => {
  const { authState, handleError } = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    data: [] as Array<Policies>,
    total_count: 0,
  });

  if (authState.access_token) {
    henceforthApi.setToken(authState.access_token);
  }

  const initialiseData = async () => {
    try {
      setLoading(true);
      let apiRes = await henceforthApi.Policies.all();
      setState({
        ...state,
        ...apiRes,
      });
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      handleError(error);
    }
  };

  useEffect(() => {
    initialiseData();
  }, []);

  const columnDefs = useMemo<ColDef[]>(() => {
    return [
      {
        headerName: "Sr No.",
        field: "_id",
        minWidth: 70,
        width: 80,
        valueGetter: (p) =>
          p.node?.rowIndex !== null && p.node?.rowIndex !== undefined
            ? `${p.node.rowIndex + 1}.`
            : "1.",
      },
      {
        headerName: "Title",
        field: "type",
        minWidth: 160,
        width: 200,
        valueFormatter: (p) => (p.value ? p.value.replace(/_/g, " ") : ""),
      },
      {
        headerName: "Content",
        field: "description",
        minWidth: 350,
        flex: 2,
        cellRenderer: (p: any) => {
          const raw = p.value || "";
          const text = raw.replace(/<[^>]*>?/gm, "");
          const truncated =
            text.length > 200 ? text.slice(0, 200) + "..." : text;
          return (
            <span className="text-slate-600 text-xs truncate" title={text}>
              {truncated || "No content"}
            </span>
          );
        },
      },
      {
        headerName: "Action",
        field: "type",
        minWidth: 90,
        width: 100,
        cellRenderer: (p: any) => {
          return (
            <div className="flex items-center">
              <Link
                to={`/policies/${p.value}`}
                className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold bg-slate-50 hover:bg-slate-100 text-slate-700 border border-slate-200 transition-colors"
              >
                <Eye className="w-3.5 h-3.5" />
                <span>View</span>
              </Link>
            </div>
          );
        },
      },
    ];
  }, []);

  return (
    <>
      <AgGridTable
        rowData={state?.data || []}
        columnDefs={columnDefs}
        loading={loading}
        domLayout="autoHeight"
        emptyMessage="No policies found"
      />
    </>
  );
};
